<template>
    <div class="check-in-record">
      <div class="background-image">
        <img class="top-image" src="@/assets/di.png" alt="Top Image" />
        <span class="welcome-text">欢迎来到</span>
        <span class="dengji">小鹅学堡</span>
        <img class="top-top-image" src="@/assets/image.png" alt="Bottom Image" />
      </div>
      <div class="appointment-container">
        <h3>当天打卡记录</h3>
        <ul class="student-names">
          <li v-for="student in checkInRecords" :key="student.id" class="student-item">
            {{ student.studentName }} - {{ student.checkinTime }}
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        checkInRecords: [],
        loading: true,
      };
    },
    methods: {
      async fetchCheckInRecords() {
       try {
         const headers = {
            Authorization: `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGFpbXMiOnsiY29ycGlkIjoid3BtSFVSRndBQUY1dUJ2ZjNRa0RzNVo1R0VWVkxsR2ciLCJ1c2VyaWQiOiJ3b21IVVJGd0FBUzdqU05NcnFabEVqeU9GbktvcEV0QSJ9LCJleHAiOjE3NDYwMjY2MzZ9.119PBbNApuBKv4CD8NBX2I2ZZ7DG1LstT52sFQw9P0s`,
         };
         const response = await axios.post('https://xbxy.xiao-e.tech/api/getDakaRecord', {
           startTime: this.getTodayStart(),
           endTime: this.getTodayEnd(),
         }, { headers });
         console.log(this.getTodayStart())
         if (response.data.code === 0) {
            console.log(response.data.data)
            this.checkInRecords = response.data.data.studentCheckinList;
          } else {
            console.error('Failed to fetch data:', response.data.errmsg);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          this.loading = false;
        }
      },
      getAuthToken() {
        return localStorage.getItem('authToken') || '';
      },
      getTodayStart() {
        const today = new Date();
        return today.toISOString().split('T')[0] + ' 00:00:00';
      },
      getTodayEnd() {
        const today = new Date();
        today.setHours(23, 59, 59);
        return today.toISOString().split('T')[0] + ' 23:59:59';
      },
    },
    mounted() {
      this.fetchCheckInRecords();
    },
  };
  </script>
  

  <style scoped>
  .check-in-record {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #5999fd;
  }
  
  .background-image {
    position: relative;
    width: 100%;
    height: 50vh;
    overflow: hidden;
  }
  
  .top-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .top-top-image {
    position: absolute;
    bottom: 120px;
    left: 50%;
    width: 182px;
    height: 189px;
  }
  
  .appointment-container {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-left: 5px;
    margin-top: -150px;
    flex: 1;
    z-index: 10;
    margin-right: 5px;
    margin-bottom: 100px;
    overflow-y: auto; /* 允许垂直滚动 */
    max-height: 400px; /* 设置最大高度 */
  }

  
  .appointment-container h3 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  }
  
  .student-names {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .student-item {
    background-color: #e0f0ff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    margin-bottom: 10px;
    box-sizing: border-box;
    text-align: center;
    color: #000000;
    font-size: 1.0em;
    width: 100%;
  }
  </style>